export const IconCopy = '/assets/icons/copy/copy.svg'
export const IconContentCopy = '/assets/icons/actions/content_copy.svg'
export const IconEdit = '/assets/icons/actions/edit.svg'
export const IconEditBlue = '/assets/icons/actions/editBlue.svg'
export const IconDelete = '/assets/icons/actions/delete.svg'
export const IconLink = '/assets/icons/links/link.svg'
export const IconWhatsApp = '/assets/icons/actions/whatsapp.svg'
export const IconEye = '/assets/icons/eyes/eyeButtonBlack.svg'
export const IconClone = '/assets/icons/copy/clone.svg'
export const IconShare = '/assets/icons/share/share.svg'
export const IconDisable = '/assets/icons/actions/cancel.svg'
export const IconEnable = '/assets/icons/actions/checked.svg'
export const IconSalesTeamRanking1st = '/assets/icons/sales/team/flag-1st.svg'
export const IconSalesTeamRanking2nd = '/assets/icons/sales/team/flag-2nd.svg'
export const IconSalesTeamRanking3rd = '/assets/icons/sales/team/flag-3rd.svg'
export const IconExpandContent = '/assets/icons/actions/expand_content.svg'
export const IconCrown = '/assets/icons/crown/crown.svg'
export const IconSalesTeamGroups = '/assets/icons/sales/team/groups.svg'
export const IconPayArrowDown = '/assets/icons/payments/payment_arrow_down.svg'
